<template>
  <!-- <div
    id="header"
    class="container-fuild"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/img/' + backgroundImage) + ')',
      backgroundSize: '100% 100%',
      height: isHomePage ? '1080px' : '400px',
    }"
  > -->
  <!-- <div
    id="header"
    class="container-fuild"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/img/' + backgroundImage) + ')',
      backgroundSize: '100% 100%',
      height: isHomePage ? '1080px' : '400px'
    }"
  > -->
  <div
    id="header"
    class="container-fuild"
    :style="{
      backgroundImage: backgroundImage,
      backgroundSize: '100% 100%',
      height: isHomePage ? '980px' : '400px',
    }"
  >
    <!-- <span style="color: #fff">{{ backgroundImage }}</span> -->
    <div v-if="isHomePage" class="carousel">
      <div class="carousel-content">
        <h1>可信赖的信息技术服务专家</h1>
        <div class="title-bar"></div>
        <h2>虚拟映射现实，数字呈现未来</h2>

        <img
          :src="require('@/assets/img/but.png')"
          alt="按钮图像"
          @click="applyForTrial"
          class="image-hover"
        />

        <!-- <button @click="applyForTrial">申请试用</button> -->
      </div>
    </div>
    <div v-if="isHomePage" class="bar-container">
      <div
        class="bar"
        :class="{ barActive: bannerFlag == 1 }"
        @click="changeBanner(1)"
      ></div>
      <div
        class="bar"
        :class="{ barActive: bannerFlag == 2 }"
        @click="changeBanner(2)"
      ></div>
      <div
        class="bar"
        :class="{ barActive: bannerFlag == 3 }"
        @click="changeBanner(3)"
      ></div>
    </div>
    <div class="header-nav container hidden-xs">
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" />
      </div>
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path" class="no-underline">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt
              v-for="(i, n) in item.children"
              :key="n"
              @click="navClick(2, i.name)"
            >
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo" />
      </div>
      <div class="header-nav-m-menu text-center">
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import store from "@/store";
import { provide } from "vue";
import Router from "vue-router";
export default {
  name: "Header",
  components: {},
  props: ["test"],
  // provide() {
  //   return {
  //     navClick: this.navClick,
  //   };
  // },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val, val.query);
        if (JSON.stringify(val.query) !== "{}") {
          console.log(111);
          this.navClick(Number(val.query.id), val.query.name);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  data() {
    return {
      bannerFlag: 1,
      bannerFlag1: undefined,
      bannerAuto: 1,
      clearTime: "",
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },

        {
          name: "关于我们",
          path: "/companyintroduction",
          children: [],
        },
        {
          name: "产品案例",
          path: "/software",
          children: [
            {
              name: "虚拟仿真",
              path: "/software/smartTown",
            },
            {
              name: "智慧平台",
              path: "/software/bigData",
            },
            {
              name: "数字孪生",
              path: "/software/digitalTwin",
            },
          ],
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
      ],
      backgroundImageIndex: 0,
      backgroundImageList: [
        "backgroundHome1.png",
        "backgroundHome2.png",
        "backgroundHome3.png",
      ],
      backgroundImage:
        "url(" + require("@/assets/img/backgroundHome" + 1 + ".png") + ")",
      isHomePage: true, // Add this line
      intervalId: null, // Add this line
    };
  },
  mounted() {
    this.preloadImages();
    this.setInter();

    // this.applyForTrial();
    this.$router.push({
      // name: "contactus",
      // path: "/contactus",
      // name: "首页",
      name: "home",
      path: "/",
    });
    // this.navClick(3, "联系我们");
    this.navClick(0);
  },

  methods: {
    // 切换首页背景图
    changeBanner(val) {
      this.bannerFlag = val;
      this.bannerFlag1 = val;
      this.isHomePage = true;
      if (val == 1) {
        this.backgroundImage =
          "url(" + require("@/assets/img/backgroundHome" + 1 + ".png") + ")";
      } else if (val == 2) {
        this.backgroundImage =
          "url(" + require("@/assets/img/backgroundHome" + 2 + ".png") + ")";
      } else {
        this.backgroundImage =
          "url(" + require("@/assets/img/backgroundHome" + 3 + ".png") + ")";
      }
      console.log(111, this.backgroundImage);
    },
    navClick(index, name) {
      console.log(222);
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      this.isHomePage = index === 0; // Add this line
      console.log(this.isHomePage, index);
      if (this.isHomePage) {
        console.log(3);
        this.backgroundImage =
          "url(" + require("@/assets/img/backgroundHome" + 1 + ".png") + ")";
        this.setInter();
      } else if (index == 1) {
        console.log(4);
        this.isHomePage = false;
        this.backgroundImage =
          "url(" + require("@/assets/img/background" + 2 + ".png") + ")";
      } else if (index === 2) {
        if (name == "产品案例") {
          return;
        }
        // if (name == "产品案例") {
        //   this.isHomePage = false;
        //   this.backgroundImage =
        //     "url(" + require("@/assets/img/background" + 3 + ".png") + ")";
        // }
        if (name == "虚拟仿真") {
          console.log(5);
          this.isHomePage = false;
          this.backgroundImage =
            "url(" + require("@/assets/img/background" + 3 + ".png") + ")";
        } else if (name == "智慧平台") {
          this.isHomePage = false;
          this.backgroundImage =
            "url(" + require("@/assets/img/background" + 5 + ".png") + ")";
        } else if (name == "数字孪生") {
          this.isHomePage = false;
          this.backgroundImage =
            "url(" + require("@/assets/img/background" + 7 + ".png") + ")";
        }
      } else if (index === 3) {
        console.log("联系我们");
        this.isHomePage = false;
        this.backgroundImage =
          "url(" + require("@/assets/img/background" + 4 + ".png") + ")";
      }
      // EventBus.$emit("nav-clicked", index, name);
      // 使用 Vuex action 更新状态
      // this.$store.dispatch("updateNav", { index, name });
      // EventBus.$emit("nav-clicked", index, name);
      // this.$store.dispatch("updateNav", { index, name });
      // EventBus.$emit('nav-clicked', index, name)
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    setInter() {
      if (!this.isHomePage) {
        clearInterval(this.clearTime);
        return;
      }
      this.clearTime = setInterval(() => {
        if (!this.isHomePage) {
          clearInterval(this.clearTime);
          return;
        }
        if (this.bannerFlag1 != undefined) {
          this.bannerAuto = this.bannerFlag1;
        }
        this.bannerFlag1 = undefined;
        if (this.bannerAuto > 3) {
          this.bannerAuto = 1;
        }
        this.bannerFlag = this.bannerAuto;
        this.backgroundImage =
          "url(" +
          require("@/assets/img/backgroundHome" + this.bannerAuto + ".png") +
          ")";
        this.bannerAuto++;
      }, 3000);
    },
    preloadImages() {
      this.backgroundImageList.forEach((image) => {
        const img = new Image();
        img.src = require("@/assets/img/" + image);
      });
    },
    // 申请试用
    // applyForTrial() {},

    applyForTrial() {
      this.$router.push({
        name: "contactus",
        path: "/contactus",
      });
      // this.backgroundImage =
      //   "url(" + require("@/assets/img/backgroundHome" + 3 + ".png") + ")";
      // console.log(this.backgroundImage, "back1111121");
      // this.$nextTick(() => {
      //   this.backgroundImage =
      //     "url(" + require("@/assets/img/backgroundHome" + 3 + ".png") + ")";
      // });
      this.navClick(3, "联系我们");
    },
    // applyForTrial() {
    //   this.$router.replace({
    //     name: "contactus",
    //     path: "/contactus",
    //   });
    // },
  },
  // watch: {
  //   $route: {
  //     handler: function (val, oldVal) {
  //       console.log(val, val.query);
  //       if (JSON.stringify(val.query) !== "{}") {
  //         console.log(111);
  //         this.navClick(val.query.id, val.query.name);
  //       }
  //     },
  //     // 深度观察监听
  //     deep: true,
  //   },
  // },
};
</script>

<!-- 你的样式代码 -->
<style scoped>
/* 按钮图像动画 */
.image-hover {
  transition: all 0.3s ease-in-out;
}

.image-hover:hover {
  transform: scale(1.1);
}
.carousel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.title-bar {
  width: 80px;
  height: 2px;
  border-radius: 50px;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
  margin: 20px 0; /* Add some margin to give space above and below the bar */
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.carousel-content h1,
.carousel-content h2 {
  max-width: 100%;
  text-align: center;
}

.carousel-content h1 {
  width: 672px;
  height: 68px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-family: "Source Han Sans CN", sans-serif;
  font-size: 56px;
  line-height: 67.2px;
}

.carousel-content h2 {
  width: 234px;
  height: 27px;
  text-align: center;
  color: rgba(255, 255, 255, 0.65);
  font-family: "Source Han Sans CN", sans-serif;
  font-size: 18px;
  line-height: 27px;
}

.carousel-content button {
  width: 152px;
  height: 54px;
  border-radius: 50px;
  border-width: 2px;
  border-style: solid;
  border-image-source: linear-gradient(
    96.68deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 127.47%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(4, 17, 36, 0.5);
  box-shadow: 0px 1px 1px rgba(4, 17, 36, 0.65);
  color: rgba(255, 255, 255, 1);
  font-family: "Source Han Sans CN", sans-serif;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
}

.bar {
  width: 40px;
  height: 6px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 5px; /* Add this line to create a 10px space between the bars */
}
.bar:hover {
  background: rgba(255, 255, 255, 0.85);
}
.barActive {
  background: rgba(255, 255, 255, 0.85);
}
.bar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90px; /* Adjust this value to fit the total width of three bars plus the space in between */
  position: absolute; /* Change from fixed to absolute */
  bottom: 150px; /* Change from 12px to 0 */
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1000; /* Add this line */
}
#header {
  position: relative; /* Add this line if it's not already there */
  /* width: 1920px; */
  height: 400px;
  margin: 0 auto;
  transition: all ease 0.6s;
  background-size: 100% 100%;
  transition: background-image 0.5s ease-in-out;
}

/* 顶部 */
/* #header {
  width: 100%;
  height: 1400px;1080px
  width: 1920px;
  height: 400px;
  background: #0ac6e7;
  transition: all ease 0.6s;
  background-size: cover; 添加这一行
  background-size: 100% 100%; 添加这一行
} */
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  // background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 130px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 130px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  /* background-color: #1e73be; */
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
/* #header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
} */
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #fff;
  text-decoration: none;
  /* border-bottom: 2px solid #fff */
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > .underline {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  /* background-color: #1e73be; */
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后下划线的样式 */
#header .header-nav .header-nav-wrapper > li.active > a .underline {
  opacity: 1;
  width: 100%;
  left: 0;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
}

/* #header .header-nav .header-nav-wrapper > li > a {
  position: relative;
  text-decoration: none;
}

#header .header-nav .header-nav-wrapper > li.active > a::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
  display: none;
}

#header .header-nav .header-nav-wrapper > li.active > a:active::after {
  display: block;
} */

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  /* width: 168px; */
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  /* background: #fff; */
  width: 104px;
  /* height: 125px; */
  background: rgba(244, 250, 255, 1);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  /* border-bottom: 1px solid #ccc; */
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  /* background: #ccc; */
}
#header .header-nav .header-nav-wrapper > li > dl > dt {
  cursor: pointer;
  /* background: #ccc; */
  text-align: center;
  color: rgba(4, 17, 36, 0.65);
  font-family: Source Han Sans CN;
  font-size: 18px;
  line-height: 22.5px;
  text-transform: uppercase;
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  /* background: #ccc; */
  /* box-shadow: 0px 1px 1px rgba(3, 20, 55, 0.3); */
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(141, 192, 37, 1) 0%,
    rgba(1, 129, 204, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 18px;
  line-height: 22.5px;
  text-transform: uppercase;
  text-decoration: none;
}
/* a:visited {
  text-decoration: none;
} */
.no-underline {
  text-decoration: none;
}

#header .header-nav .header-nav-wrapper > li > dl > dt a:visited {
  cursor: pointer;
  /* background: #ccc; */
  text-align: center;
  color: rgba(4, 17, 36, 0.65);
  font-family: Source Han Sans CN;
  font-size: 18px;
  line-height: 22.5px;
  text-transform: uppercase;
  text-decoration: none;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 130px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue